import type { FaireProductEntity } from "../../entity_types/product";

export const p_qxsgajkmqe: FaireProductEntity = {
  token: "p_qxsgajkmqe",
  type: "product",
  name: "Animal Safari Embroidered Baby Cardigan Sweater (Organic)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/d67ea1daa58cc72577deb98a7f6987017738f4fde50d1082a540654e6c2b9f27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3782f8ad7d3028d2ba48293dc28062dc504acbfeb5dc26ad5a713bafbb899955.jpeg",
    "https://cdn.faire.com/fastly/e9284c400a119ff4ad006695d4696766a0a319ff9ba1ea3b0484888dd18e4a89.jpeg",
    "https://cdn.faire.com/fastly/9348e11a44c9eb03399619dbbdb582a9a5519290c759ae67a56bade59c5afe6d.jpeg",
    "https://cdn.faire.com/fastly/eeb2902cc28953a477d459e94bc2dcac0842614921a2df8f1713d64fadb94308.jpeg",
    "https://cdn.faire.com/fastly/58c2b21211c34e7cc166af48c61508b4b124fc3c263f1650740ed6325ca6b7b9.jpeg",
    "https://cdn.faire.com/fastly/da033e748bd8ef99a3dc512a58602c58680c288251468fdab1c906c01f5049a2.jpeg",
    "https://cdn.faire.com/fastly/40ce45a6f31a113217af0bdfa9eeeca7a45cd11feb99f1a3b935d07d19098aa2.jpeg",
    "https://cdn.faire.com/fastly/355f36d41f247cf688ce8d4d491f62333e53a9779d9c6e6281986db9cf744c0d.jpeg",
    "https://cdn.faire.com/fastly/f905e65ddc5d24c455382f68da420b2d627852f8e4a900e0d882c4b2c32dc6e0.jpeg",
    "https://cdn.faire.com/fastly/9ad6d21f1a995da9a7ae99e56b9a7ce664eaa7aa759e2be8226cf3d8d315de0b.jpeg",
    "https://cdn.faire.com/fastly/7d40f852c221ed27481a70ba0bea5b1f7a577244070522d6711943c2ff0de259.jpeg",
    "https://cdn.faire.com/fastly/0d42e281cfb5f384599661e9eba710598d0efe1f16fe54491207c73467151eb2.jpeg",
    "https://cdn.faire.com/fastly/954216ec2706e234d8802f651ab9160da6486b47651d3019d6a7f992d0867111.jpeg",
    "https://cdn.faire.com/fastly/750b5515f164227a2c0b855e093908e34e8f789e1f057b2a2c43bda8ccf2cb6a.jpeg",
    "https://cdn.faire.com/fastly/a6795076da97320a8de4f89a17bd3bd268c8161c4821d06a9e88b0392a625b1b.jpeg",
    "https://cdn.faire.com/fastly/28d721a957ed62009d8d353355a30eded809c5ef55ee7a4b8ac59d8e1d90ab16.jpeg",
    "https://cdn.faire.com/fastly/a32a523c368a25d5162d55db01bd0be27f35c34be1fe5b6fbb734431676d11a4.jpeg",
    "https://cdn.faire.com/fastly/7c1a24df1969108c7d39e998ffa5bbe1dc1bb8d4d9ea0adaceb8e21cca0c01de.jpeg",
    "https://cdn.faire.com/fastly/3ab4e99828bcae21072dd4b711a218ecb537725297066512e5d69a946b4f5c9d.jpeg",
    "https://cdn.faire.com/fastly/9fbc54256807c60789c1f210ba58341ee2b21f35a67962fac69ee8874f125b74.jpeg",
    "https://cdn.faire.com/fastly/56148fddf69d3f0a6d29676b18d10c6a249d7fe1611756dd3b7b6dfa6967b54d.jpeg",
    "https://cdn.faire.com/fastly/5faa95271c333bd780ed81a6108c4fe492972ad98aceaaed43a24b050b29155d.jpeg",
    "https://cdn.faire.com/fastly/6cfdf20b243a8109126c7f15c7745a9d48ef7e9f0a43de7f1345a6fd81642a8b.jpeg",
    "https://cdn.faire.com/fastly/f9b61bc71d86477a4aa7809867ec644c4bb56cb3be4c36fc90349b21fe83a377.jpeg",
    "https://cdn.faire.com/fastly/7debce390f8f606dfbe5469bd728015041b8de164d6417f34ef3ed7c4eda5856.jpeg",
  ],
  priceDollars: 26,
  description:
    "100% organic cotton sweater knit long sleeve cardigan with sweet & fun safari animals embroidery in front, super cute!\n• PAIR with our cable knit legging pant in petal pink color - style# 777032\n• All-season, lightweight and breathable organic cotton, comfy and cozy.\n• Eco-friendly, chemical free and non-toxic, good for baby's delicate skin.\n• Machine washable, durable and long lasting organic baby clothes.\n• Ethically & lovingly produced in India.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:34.690Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
